import useCurrencyStore from "./useCurrencyStore";
import useOrgStore from "./useOrgStore";
import useUserStore from "./useUserStore";
import useAppConfigStore from "./useAppConfigStore";
import useTermsStore from "./useTermsStore";
import useFeatureStore from "./useFeatureStore";
import useFilterStore from "./useFilterStore";
import { useQuickAddStore } from "./quickAddStore";
import useSidebarStore from "./sidebarStore";
import useSubscriptionFeatureStore from "./useSubscriptionFeatureStore";
import useFinancialYearLockStore from "./useFinancialYearLockStore";
import useAddressConfigStore from "./useAddressConfigStore";

import useBootstrapStore from "./useBootstrapStore";

export const resetAllStores = () => {
  // 1. Clear Data Stores
  useUserStore.getState().clearUser();
  useOrgStore.getState().clearOrganization();
  useBootstrapStore.getState().clearBootstrap();
  useCurrencyStore.getState().clearCurrencySymbol();
  useAppConfigStore.getState().resetAppConfig();
  useTermsStore.getState().clearTerms();
  useFeatureStore.getState().clearFeatures();
  useFinancialYearLockStore.getState().clearFinancialYearLockStore();
  useAddressConfigStore.getState().resetAddressConfig();

  // 2. Clear UI & Utility Stores
  useFilterStore.getState().clearAllFilters();
  useQuickAddStore.getState().resetToDefaults();
  useSidebarStore.getState().clearSelectedPath();

  useSubscriptionFeatureStore.getState().clearFeatureCodes();

  console.log("All Zustand stores have been reset.");
};
